import { createWithEqualityFn } from 'zustand/traditional';

interface WorkspaceLayoutState {
  rightPanels: Record<string, number>;
}

interface WorkspaceLayoutActions {
  reserveRightPanel: (key: string, width: number) => void;
  releaseRightPanel: (key: string) => void;
}

export const workspaceLayoutStore = createWithEqualityFn<
  WorkspaceLayoutState & WorkspaceLayoutActions
>((set) => ({
  rightPanels: {},
  reserveRightPanel: (key, width) => {
    set((state) => ({ ...state, rightPanels: { ...state.rightPanels, [key]: width } }));
  },
  releaseRightPanel: (key) => {
    set((state) => {
      const rightPanels = { ...state.rightPanels };
      delete rightPanels[key];
      return { ...state, rightPanels };
    });
  },
}));

export const selectRightPanelWidth = (state: WorkspaceLayoutState) =>
  Math.max(0, ...Object.values(state.rightPanels));
